import {
  deleteDataAuto,
  fetchDataAuto,
  patchDataAuto,
  postDataAuto,
} from "../services/auto";

const handleFetchRoles = async () => {
  const uri = `api/roles`;
  const response = fetchDataAuto({ uri });
  return response;
};

const handleCreateRole = async (data: any) => {
  const uri = `api/roles`;
  const response = postDataAuto({ data, uri });
  return response;
};

const handleUpdateRole = async ({ data, _id }: any) => {
  const uri = `api/roles/${_id}`;
  const response = patchDataAuto({ data, uri });
  return response;
};

const handleDeleteRole = async ({ _id }: any) => {
  const uri = `api/roles/${_id}`;
  const response = deleteDataAuto({ uri });
  return response;
};

export {
  handleFetchRoles,
  handleCreateRole,
  handleUpdateRole,
  handleDeleteRole,
};
